export default function(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
}



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/d3-array/src/threshold/sturges.js
// module id = 21H5
// module chunks = 0